module.exports = __webpack_public_path__ + "img/Facebook.c9e54152.png";